import React from "react";
import { useStyles } from "./styles";

import { StatisticTitle } from "./StatisticTitle/StatisticTitle";
import { StatisticCards } from "./StatisticCards/StatisticCards";
import { Divider, Grid } from "e100-react-components";

export const NavigationHistoryPathStatistics = () => {
  const classes = useStyles();

  return (
    <Grid>
      <Grid item classes={{ root: classes.container }}>
        <Grid item xs={12}>
          <StatisticTitle />
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <StatisticCards />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
};
